import Vue from "vue";
import Vuetify from "vuetify/lib";
import VueClipboard from "vue-clipboard2";
import VueGtag from "vue-gtag";
import VeeValidate from "vee-validate";
import VueRssFeed from "vue-rss-feed";

Vue.use(Vuetify, {
  iconfont: "md"
});

Vue.use(VueGtag, {
  config: { id: "G-6QZPWG1RCB" }
});

Vue.use(VueClipboard);
Vue.use(VeeValidate);
Vue.use(VueRssFeed);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#c5a93b"
        // secondary: '#b0bec5',
        // accent: '#8c9eff',
        // error: '#b71c1c',
      }
    }
  }
});
